import { getStorage, setStorage } from '@/utils/storage'

const state = {
    contactOptions: getStorage('contactOptions') || [], // 联系方式类型
}

const getters = {
    contactOptions: (state) => state.contactOptions,
}

const mutations = {
    setContactOptions: (state, contactOptions) => {
        state.contactOptions = contactOptions
    },
}

const actions = {
    setContactOptions({ commit }, contactOptions) {
        commit('setContactOptions', contactOptions)
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/publicData.js